import React from "react";
import { Link } from "react-router-dom";
import { FaMapMarkerAlt, FaUser, FaFutbol } from "react-icons/fa";

const TeamItem = ({ team }) => {
  return (
    <Link to={`/rakip-bul/${team.slug}`} className="block">
      <div className="w-full max-w-md mx-auto bg-white rounded-3xl shadow-lg overflow-hidden m-4 transform transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 cursor-pointer border border-gray-200">
        {/* Header with Gradient and Image */}
        <div className="relative bg-[#4d9041] p-6 text-center">
          <div className="flex justify-center items-center">
            <img
              className="h-32 w-32 object-cover rounded-full border-4 border-white shadow-lg transition-transform duration-300 hover:scale-110"
              src={
                team.image ||
                "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541"
              }
              alt={`${team.name || "Takım"}'s profile`}
            />
          </div>
          <h2 className="text-2xl font-bold text-white mt-3">
            {team.name || "İsim Belirtilmemiş"}
          </h2>
          <span className="inline-block mt-1 px-4 py-1 bg-white/20 text-white text-sm font-medium uppercase tracking-wider rounded-full shadow-md">
            {team.city || "Şehir Belirtilmemiş"}
          </span>
        </div>

        {/* Team Details */}
        <div className="p-6 bg-gray-50">
          <div className="space-y-4">
            {/* Info Grid */}
            <div className="grid grid-cols-2 gap-4 text-gray-800">
              <div className="flex items-center gap-2">
                <FaMapMarkerAlt className="text-[#4d9041]" />{" "}
                <span className="font-medium">Şehir:</span>
              </div>
              <p className="font-semibold text-right">{team.city || "N/A"}</p>

              <div className="flex items-center gap-2">
                <FaUser className="text-[#4d9041]" />{" "}
                <span className="font-medium">Kaptan:</span>
              </div>
              <p className="font-semibold text-right truncate">
                {team.captain.fullname || "N/A"}
              </p>

              <div className="flex items-center gap-2">
                <FaUser className="text-[#4d9041]" />{" "}
                <span className="font-medium">Oyuncular:</span>
              </div>
              <p className="font-semibold text-right">
                {team.players.length || "N/A"}
              </p>
            </div>
          </div>

          {/* Match Count */}
          <div className="mt-8 text-center border-t border-gray-200 pt-6">
            <p className="text-gray-700 text-lg">
              Bu takıma{" "}
              <span className="font-bold text-[#4d9041]">
                {team.matchQuantity || 0}
              </span>{" "}
              kere{" "}
              <span className="font-semibold text-gray-800 uppercase bg-gray-100 px-2 py-1 rounded-md">
                halisahabul
              </span>{" "}
              ile istek atıldı.
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default TeamItem;
